<template>
  <div class="handover-task-dialog-container">
    <el-dialog
      class="handover-task-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="handover-task-dialog-top">
        <p class="tit">办理离职</p>
        <i class="icon iconfont iconicon_close1 activeIconHover" @click="handleClose"></i>
      </div>

      <div class="handover-task-dialog-content" v-loading="loading">
        <div class="handover-task-left">
          <p class="tit">项目</p>
          <ul>
            <li
              class="item"
              :class="{ 'active': item.project_id === projectId }"
              v-for="item in projectTaskList"
              :key="item.project_id"
              @click="handleChosProject(item.project_id)"
            >
              <i class="icon iconfont iconicon_action_item"></i>
              <toolTip style="width: 0; flex: 1" :title="item.title">
                {{ item.title }}
              </toolTip>
            </li>
          </ul>
        </div>

        <div class="handover-task-right">

          <div class="handover-task-content">
            <div class="tit-wrap">
              <p class="tit">任务</p>
              <span
                class="tit-btn"
                :class="chosAll ? 'text-red' : 'letterHover'"
                @click="handleChosAll(!chosAll)"
              >
                {{ chosAll ? '清空' : '全选' }}
              </span>
            </div>
            <ul class="task-list-wrap">
              <li
                class="task-list-item"
                v-for="item in taskList"
                :key="item.task_list_id"
              >
                <div class="msg item">
                  <span
                    class="select-icon"
                    :class="{ 'is-checked': item.chosAll }"
                    @click="handleChosListAll(item, !item.chosAll)"
                  ></span>
                  <toolTip style="width: 0; flex: 1" :title="item.title">
                    {{ item.title }}
                  </toolTip>
                  <!-- <span class="title task-list-title">{{ item.title }}</span> -->
                </div>

                <ul>
                  <li v-for="task in item.new_tasks" :key="task.id">
                    <div class="msg item task-item">
                      <span
                        class="select-icon"
                        :class="{ 'is-checked': task.checked }"
                        @click="handleChos(task, item)"
                      ></span>
                      <toolTip style="width: 0; flex: 1" :title="task.task_name">
                        {{ task.task_name }}
                      </toolTip>
                      <!-- <span class="title">{{ task.task_name }}</span> -->
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="docking-user-wrap">
            <div class="docking-tit">
              <i class="icon iconfont iconicon_task_matcher"></i>
              对接人
            </div>
            <div class="docking-user">
              <wf-select
                v-if="!dockingUser.uid"
                lazy
                :placement="'top'"
                :load="loadProjectMembers"
                :props="{value: 'uid', label: 'realname'}"
                v-model="dockingUserUid"
                @change="leaderChange"
              >
                <template>
                  <span class="add-btn letterHover">添加</span>
                </template>
                <div slot="item" slot-scope="{data}">
                  <Myavatar width="28px" height="28px" :imgUrl="data.user_avatar" :userName="data.realname">
                    <span>{{ data.realname }}</span>
                  </Myavatar>
                </div>
              </wf-select>
              <div class="user-item" v-else>
                <Myavatar :imgUrl="dockingUser.user_avatar" width="28px" height="28px" :userName="dockingUser.realname">
                  <span>{{ dockingUser.realname }}</span>
                </Myavatar>
                <i class="icon iconfont iconicon_empty" @click="handleDel()"></i>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="handover-task-dialog-footer">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <wf-button
          type="primary"
          :disabled="btnDisabled"
          @click="handldeSubmit"
          :loading="btnLoading"
        >
          确定
        </wf-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// api
import api from '@/services/api/staffManagement/staffManagement'
import apiTask from '@/services/api/task/task'

export default  {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    dataset: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    // 已选择的任务id数组
    chosTasks() {
      let arr = []
      if (this.projectItem.project_task_list) {
        this.projectItem.project_task_list.forEach(item => {
          item.new_tasks.forEach(obj => {
            if (obj.checked === true) {
              arr.push(obj.id)
            }
          })
        })
      }

      return arr
    },
    // 保存按钮是否置灰
    btnDisabled() {
      return !this.dockingUserUid || !this.chosTasks.length
    }
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.init()
      }
    }
  },
  data() {
    const _ts = this
    return {
      loading: false,
      btnLoading: false,
      unprocessedTasks: 0, // 未完成任务数
      chosAll: false, // 是否全选
      dockingUser: {}, // 交接人
      dockingUserUid: 0, // 交接人id
      projectId: null, // 项目id
      projectItem: {}, // 已选则的项目
      projectTaskList: [], // 离职人员未完成的项目任务列表
      taskList: [], // 任务列表
      // 加载项目成员列表
      loadProjectMembers: async (resolve, params) => {
        if (!_ts.projectId) return
        let membersArr = []
        const param = {
          project_id: _ts.projectId,
          working_status: '在职',
          ...params
        }
        const result = await apiTask.getProjectMembers(param)
        if (result) {
          result.forEach(res => {
            for (let key in res) {
              if (res[key].length) {
                membersArr.push(...res[key]) //获取成员形成一个数组
              }
            }
          })
          resolve(membersArr)
        }
      },
    }
  },
  methods: {
    async init (isNeedToDetermine) {
      this.loading = true
      const uid = this.dataset.uid
      const res = await api.getResignUserTasks({ uid })
      if (res) {
        this.projectTaskList = res.data

        if (this.projectTaskList.length) {
          this.unprocessedTasks = 0

          this.projectTaskList.forEach(projectItem => {
            projectItem.project_task_list.forEach(listItem => {
              this.unprocessedTasks += listItem.new_tasks.length
            })
          })

          // 手动切换到第一个项目
          this.handleChosProject(this.projectTaskList[0].project_id)
        }

        if (isNeedToDetermine && !this.projectTaskList.length) {
          // 任务已全部交接完成
          this.resetForm()
          this.$emit('complete')
          this.$emit('handleClose')
        }

        this.loading = false
      }
    },
    // 选取了项目，获取项目下的任务列表
    handleChosProject(projectId) {
      // 重置交接人数据、已选数据
      this.dockingUser = {}
      this.dockingUserUid = 0
      if (this.projectItem.project_id) {
        this.handleChosAll(false)
      }

      this.projectId = projectId
      this.projectItem = this.projectTaskList.find(item => item.project_id === projectId)
      if (this.projectItem) {
        this.taskList = this.projectItem.project_task_list
      }
    },
    // 全选
    handleChosAll(val) {
      this.chosAll = val
      // 根据全选或者清空操作已选项目下的任务清单的全选操作
      this.projectItem.project_task_list.forEach(item => {
        this.handleChosListAll(item, val)
      })
    },
    // 全选了项目清单
    handleChosListAll(item, isChosAll) {
      this.$set(item, 'chosAll', isChosAll)
      if (item.chosAll) {
        // 全选
        this.listChosAllFn(item, true)
      } else {
        // 全取消选择
        this.listChosAllFn(item, false)
      }
    },
    // 任务清单的全选操作
    listChosAllFn(item, val) {
      for (let i = 0, len = item.new_tasks.length; i < len; i++) {
        this.$set(item.new_tasks[i], 'checked', val)
      }
    },
    // 选择了任务
    handleChos(item, listItem) {
      this.$set(item, 'checked', !item.checked)

      // 检测任务清单列表下的所有任务是否已选
      const val = listItem.new_tasks.every(item => item.hasOwnProperty('checked') && item.checked === true)
      this.$set(listItem, 'chosAll', val)
    },
    resetForm() {
      this.chosAll = false
      this.dockingUser = {}
      this.dockingUserUid = 0
      this.projectItem = {}
      this.taskList = []
    },
    handleClose() {
      this.resetForm()
      this.$emit('handleClose', this.unprocessedTasks)
    },
    async handldeSubmit() {
      this.btnLoading = true
      const param = {
        taskIds: this.chosTasks,
        resign_uid: this.dataset.uid,
        receive_uid: this.dockingUserUid,
        project_id: this.projectId
      }
      try {
        const res = await api.resignHandoverTasks(param)
        if (res) {
          this.btnLoading = false
          this.$message({
            message: '任务交接完成',
            type: 'success'
          })
          this.resetForm()

          this.$nextTick(() => {
            this.init(true)
          })
        }
      } catch (error) {
        this.btnLoading = false
      }

    },
    handleDel() {
      this.dockingUser = {}
      this.dockingUserUid = 0
    },
    leaderChange(item) {
      // console.log(item, 111)
      this.dockingUser = item
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.handover-task-dialog-container {
  .handover-task-dialog {
    .el-dialog {
      width: 1000px;
      margin: 0 !important;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .el-dialog__header {
        padding: 0 !important;
      }
      .el-dialog__body {
        padding: 0 !important;
        .handover-task-dialog-top {
          width: 100%;
          padding: 16px 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .handover-task-dialog-content {
          height: 765px;
          padding: 0 0 0 24px;
          box-sizing: border-box;
          border-top: 1px solid rgba(32, 32, 32, .08);
          border-bottom: 1px solid rgba(32, 32, 32, .08);
          display: flex;
          .item {
            width: 100%;
            height: 48px;
            padding: 0 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            line-height: 48px;
            cursor: pointer;
            &:hover {
              @include bgColorOpacity(.04);
            }
            &:active,
            &.active {
              @include bgColorOpacity(.08);
              &:hover {
                @include bgColorOpacity(.08);
              }
            }
            .iconicon_action_item {
              font-size: 12px;
              @include fontColorOpacity(.6);
              margin-right: 8px;
            }
          }
          .handover-task-left {
            width: 276px;
            padding-right: 24px;
            box-sizing: border-box;
            border-right: 1px solid rgba(32, 32, 32, .08);
            .tit {
              font-size: 14px;
              line-height: 48px;
              @include fontColorOpacity(.6);
              padding: 16px 0 0 16px;
              box-sizing: border-box;
            }
            .item {
              font-weight: normal;
            }
          }
          .handover-task-right {
            width: 0;
            flex: 1;
            .handover-task-content {
              padding: 16px 0 0;
              box-sizing: border-box;
              .tit-wrap {
                width: 100%;
                padding: 0 24px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                line-height: 48px;
                .tit {
                  @include fontColorOpacity(.6)
                }
                .tit-btn {
                  cursor: pointer;
                }
              }
              .task-list-wrap {
                height: 646px;
                overflow-y: scroll;
                .task-list-item {
                  padding: 0 24px;
                }
                .task-item {
                  font-weight: normal;
                  padding-left: 40px;
                }
                .select-icon {
                  display: block;
                  width: 16px;
                  height: 16px;
                  border: 1px solid rgba(32, 32, 32, .6);
                  border-radius: 2px;
                  box-sizing: border-box;
                  margin-right: 8px;
                  &.is-checked {
                    background: #2682FF;
                    position: relative;
                    border: none;
                    &::after {
                      content: '';
                      display: block;
                      font-family: "iconfont";
                      content: "\e7a7";
                      font-size: 12px;
                      line-height: 12px;
                      height: 12px;
                      position: absolute;
                      left: 50%;
                      top: 50%;
                      transform: translate(-50%, -50%);
                      color: #fff;
                    }
                  }
                }
                .task-list-title {
                  font-weight: 500;
                }
              }
            }
            .docking-user-wrap {
              width: 100%;
              height: 53px;
              display: flex;
              align-items: center;
              border-top: 1px solid rgba(32, 32, 32, .08);
              box-sizing: border-box;
              .docking-tit {
                display: flex;
                align-items: center;
                padding-left: 40px;
                font-size: 14px;
                margin-right: 16px;
                @include fontColorOpacity(.6);
                i {
                  font-size: 14px;
                  margin-right: 4px;
                }
              }
              .docking-user {
                .user-item {
                  padding: 6px 16px;
                  border-radius: 4px;
                  @include bgColorOpacity(.04);
                  display: flex;
                  align-items: center;
                  &:hover {
                    i {
                      display: block;
                    }
                  }
                  i {
                    color: #BFBFBF;
                    cursor: pointer;
                    font-size: 16px;
                    margin-left: 8px;
                    display: none;
                  }
                }
              }
            }
          }
        }
        .handover-task-dialog-footer {
          width: 100%;
          height: 64px;
          padding: 16px 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .wf-button {
            width: 76px;
            margin-left: 24px;
          }
        }
      }
    }
  }
}
</style>
